import { Box, Button, Link, Flex, Divider } from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import {
  useColorMode,
  useColorModeValue,
  IconButton,
  useDisclosure,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { FaMoon, FaSun } from "react-icons/fa";
import { BiMenu, BiMenuAltLeft } from "react-icons/bi";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { NavHashLink } from "react-router-hash-link";
import resume from "../Assets/Resume/Hemant-Yadav-Resume.pdf";
import "animate.css";
import AOS from "aos";
import { themeContext } from "../Context";
import Toggle from "../Toggle/Toggle";
import "./Navbar.css";

export const Navbar = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const { onClose, onOpen, isOpen } = useDisclosure();

  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  // const openResume = (url) => {
  //   console.log(url,"URL")
  //   window.open(url);
  // };
  const openResume = (url) => {
    if (!url) {
      console.error("Invalid URL passed to openResume.");
      return;
    }
    window.open(url, "_blank"); // Open the resume in a new tab
  };
  

  return (
    <Box
      // bg="#white"
      // boxShadow={darkMode ? "white 0px 3px 8px" : "#FCA61F 0px 3px 8px"}
      // position="sticky"
      // zIndex={"overlay"}
      // top="0"
      // // className={"bg"}
      // // color={"white"}
      // p={"5px 0"}
      // fontSize={"19px"}
      // // style={{ backgroundColor: darkMode ? "black" : "" }}
      // backgroundColor={darkMode ? "#162030" : ""}
        position="fixed" // Make the navbar fixed
  width="100%" // Ensure full width
  top="0" // Keep it at the top
  zIndex="1000" // Ensure it's above other content
  bg={darkMode ? "#162030" : "white"} // Background color
  boxShadow={darkMode ? "white 0px 3px 8px" : "#FCA61F 0px 3px 8px"}
  // p={"5px 0"}
  fontSize={"19px"}
    >
      <nav id="nav-menu" className="nav-menu">
        <Flex
          m="0 30px"
          p={"10px"}
          alignItems={"center"}
          justifyContent={"space-between"}
          fontFamily="initial"
        >
          {/* <Box
            w="40%"
            color={"#FD562A"}
            fontWeight={"bold"}
            className="nav-logo"
            fontSize="20px"
            textAlign="start"
          > */}
          <div className="n-left ">
            <div
              className="n-name nav-logo"
              style={{ color: darkMode ? "white" : "" }}
            >
              Hemant
            </div>
            <Toggle />
          </div>

          {/* </Box> */}
          <Flex
            p={"10px"}
            justifyContent={"space-between"}
            mt={"10px"}
            alignItems={"center"}
          >
            <Box
              display={{
                base: "flex",
                sm: "flex",
                md: "flex",
                lg: "none",
                xl: "none",
                "2xl": "none",
              }}
              w={"10"}
              h={"10"}
              fontSize={"30px"}
              size={"20px"}
              onClick={onOpen}
              // border={"1px solid red"}
              style={{ color: darkMode ? "white" : "black" }}
            >
              <BiMenu />
            </Box>
            <Drawer isOpen={isOpen} onClose={onClose} placement="right">
              <DrawerOverlay />
              <DrawerContent   style={{ bg: darkMode ? "white" : "#171518" }}>
                <DrawerCloseButton
                  style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                  color={"white"}
                  border={"1px solid #171518"}
                />
                <DrawerHeader
                  fontFamily={"cursive"}
                  color={"orange"}
                  fontWeight={"extrabold"}
                  // bg="#171518"
                  // style={{ bg: darkMode ?  "#171518":"white" }}
                  backgroundColor={darkMode ? "#162030" : ""}
                >
                  {"Hemant Yadav"}
                </DrawerHeader>
                <DrawerBody
                  fontFamily={"cursive"}
                  color={darkMode ? "black" : ""}
                  // bg="#171518"
                  // style={{ bg: darkMode ? "#171518" : "" }}
                  backgroundColor={darkMode ? "#162030" : ""}
                >
                  <VStack alignItems={"start"}>
                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                      colorScheme={darkMode ? "#171518" : "gray"}
                    
                    >
                      <NavHashLink
                      
                        data-aos="zoom-in"
                        className="nav-link home nav_style"
                        // style={{ textDecoration: "none", color: "white" }}
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#"
                      >
                        Home
                      </NavHashLink>
                    </Button>
                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                    
                      colorScheme={darkMode ? "#171518" : "gray"}
                    >
                      <NavHashLink
                        className="nav-link about"
                        // style={{ textDecoration: "none", color: "white" }}
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#about"
                      >
                        About
                      </NavHashLink>
                    </Button>

                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                      colorScheme={darkMode ? "#171518" : "gray"}
                    >
                      <NavHashLink
                        className="nav-link experience"
                        // style={{ textDecoration: "none", color: "white" }}
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#experience"
                      >
                        Experience
                      </NavHashLink>
                    </Button>


                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                      colorScheme={darkMode ? "#171518" : "gray"}
                    >
                      <NavHashLink
                        className="nav-link skills"
                       
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#skills"
                      >
                        Skills
                      </NavHashLink>
                    </Button>
                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                      colorScheme={darkMode ? "#171518" : "gray"}

                    >
                      <NavHashLink
                        className="nav-link projects"
                     
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#projects"
                      >
                        Projects
                      </NavHashLink>
                    </Button>
                    <Button
                      onClick={onClose}
                      variant={"ghost"}
                      colorScheme={darkMode ? "#171518" : "gray"}
                    
                    >
                      <NavHashLink
                        className="nav-link contact"
                        style={{ color: darkMode ? "white" : "black",textDecoration: "none" }}
                        to="/#contact"
                      >
                        Contact
                      </NavHashLink>
                    </Button>
                  </VStack>
                  <HStack
                    w={"full"}
                    justifyContent={"space-evenly"}
                    pos={"absolute"}
                    bottom={"5"}
                    left={"0"}
                  >
                    {/* <Link
                      fontWeight={"bold"}
                      borderRadius={"5px"}
                      fontFamily={"cursive"}
                      className="nav-link resume"
                      id="resume-button-1"
                      href={resume}
                      download={true}
                      // onClick={openResume}
                      target="_blank"
                    >
                      <Button
                        onClick={() =>
                          openResume(
                            "https://drive.google.com/file/d/1NGeAuR1ECeB_vN5EKhOSW5AYGsSxeGsI/view?usp=sharing"
                          )
                        }
                        backgroundColor={"orange"}
                        className="button n-button"
                        color={"white"}
                        _hover={"none"}
                      >
                        Resume
                      </Button>
                    </Link> */}
                    <Link
              fontWeight={"bold"}
              // borderRadius={"5px"}
              fontFamily={"cursive"}
              className="nav-link resume"
              id="resume-button-1"
              href={resume}
              download={true}
              target="_blank"
            >
              <Button
                onClick={() =>
                  openResume(
                    "https://drive.google.com/file/d/1HB4sxQnjmlM1nWzvcng85FF9-1qe_fhu/view?usp=sharing"
                  )
                }
                id="resume"
                className="button n-button"
                backgroundColor={"orange"}
                color={"white"}
                // height={"20px"}
                fontSize={"16px"}
              >
                Resume
                <span>&#8595;</span>
              </Button>
            </Link>
                  </HStack>
                </DrawerBody>
              </DrawerContent>
            </Drawer>
          </Flex>
          <Flex
            w={"55%"}
            id="navflex"
            alignItems={"center"}
            justifyContent={"space-between"}
            display={{
              base: "none",
              sm: "none",
              md: "none",
              lg: "flex",
              xl: "flex",
              "2xl": "flex",
            }}
          >
            <NavHashLink
              className="nav-link home"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#"
              style={{ color: darkMode ? "white" : "black" }}
            >
              Home
            </NavHashLink>
            <NavHashLink
              className="nav-link about nav-home"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#about"
              style={{ color: darkMode ? "white" : "black" }}
            >
              About
            </NavHashLink>

            <NavHashLink
              className="nav-link about nav-home"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#experience"
              style={{ color: darkMode ? "white" : "black" }}
            >
              Experience
            </NavHashLink>
            <NavHashLink
              className="nav-link skills"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#skills"
              style={{ color: darkMode ? "white" : "black" }}
            >
              Skills
            </NavHashLink>
            <NavHashLink
              className="nav-link projects"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#projects"
              style={{ color: darkMode ? "white" : "black" }}
            >
              Projects
            </NavHashLink>

            <NavHashLink
              className="nav-link contact"
              activeClassName="active"
              id="navbar-home"
              smooth
              to="/#contact"
              style={{ color: darkMode ? "white" : "black" }}
            >
              Contact
            </NavHashLink>
            <Link
              fontWeight={"bold"}
              // borderRadius={"5px"}
              fontFamily={"cursive"}
              className="nav-link resume"
              id="resume-button-1"
              href={resume}
              download={true}
              target="_blank"
            >
              <Button
                onClick={() =>
                  openResume(
                    "https://drive.google.com/file/d/1HB4sxQnjmlM1nWzvcng85FF9-1qe_fhu/view?usp=sharing"
                  )
                }
                id="resume"
                className="button n-button"
                backgroundColor={"orange"}
                color={"white"}
                // height={"20px"}
                fontSize={"16px"}
              >
                Resume
                <span>&#8595;</span>
              </Button>
            </Link>
          </Flex>
        </Flex>
      </nav>
    </Box>
  );
};
